import {Component, inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppPaginationComponent} from "@shared/components/tables/app-pagination/app-pagination.component";
import {AppPaginationBaseAbstract} from "@shared/commons/pagination-base-abstract.utils";
import {AlertService} from "@core/services/alert.service";
import {AppTableComponent} from "@shared/components/tables/app-table/app-table.component";
import {AppTableBodyTemplateDirective, AppTableHeaderTemplateDirective} from "@shared/components/tables/app-table/directives/app-table.directives";
import {AppTableHeaderColumnComponent} from "@shared/components/tables/app-table-header-column/app-table-header-column.component";
import {AppInputComponent} from "@shared/components/forms/app-input/app-input.component";
import {FormsModule} from "@angular/forms";
import {AppEmptyAlertMessageComponent} from "@shared/components/commons/app-empty-alert-message/app-empty-alert-message.component";
import {CampaignsApiService} from "@core/services/api/campaigns-api.service";
import {Router} from "@angular/router";
import {AppLoadingOverlayComponent} from "@shared/components/commons/app-loading-overlay/app-loading-overlay.component";

@Component({
    selector: 'app-campaigns-list',
    standalone: true,
    imports: [
        CommonModule,
        AppPaginationComponent,
        AppTableComponent,
        AppTableHeaderTemplateDirective,
        AppTableHeaderColumnComponent,
        AppInputComponent,
        FormsModule,
        AppTableBodyTemplateDirective,
        AppEmptyAlertMessageComponent,
        AppLoadingOverlayComponent
    ],
    templateUrl: './campaigns-list.component.html',
    styleUrl: './campaigns-list.component.scss'
})
export class CampaignsListComponent extends AppPaginationBaseAbstract implements OnInit {
    protected items: any[] = [];

    private router = inject(Router);
    private alertService = inject(AlertService);
    private campaignsApiService = inject(CampaignsApiService);

    constructor() {
        super();
    }

    onInit(): void {
        this.addCustomSort([{field: 'createdAt', direction: 'desc'}]);
    }

    findAll(params: any): void {
        this.campaignsApiService.findAll(params)
            .subscribe({
                next: (response: any) => {
                    const data = response.data;
                    this.items = data.result || [];
                    this.pagination.itemsAmount = data.totalResults;
                    this.setLoading(false);
                },
                error: () => this.alertService.operationFailure()
            });
    }

    getStatusBadgeClass(status: string): string {
        const classes: any = {
            'ACTIVE': 'badge bg-success',
            'FINISHED': 'badge bg-primary',
        };
        return classes[status] || 'badge bg-light text-dark';
    }

    getStatusLabel(status: string): string {
        const labels: any = {
            'ACTIVE': 'Ativa',
            'FINISHED': 'Finalizada'
        };
        return labels[status] || status;
    }

    openCampaignDetails(campaign: any): void {
        this.router.navigate(['/campaigns', campaign.id]);
    }
}